import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { BasketTicketItem } from 'src/app/models/(basket)/Basket.model';
import { SubTicket } from 'src/app/models/(item)/ticket/SubTicket.model';
import { Ticket } from 'src/app/models/(item)/ticket/Ticket.model';
import { ApiService } from 'src/app/services/core/api.service';
import { AppService } from 'src/app/services/core/app.service';
import { BasketService } from './basket.service';
import * as moment from 'moment';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class TicketService {
  isLocal: BehaviorSubject<boolean>;
  tickets$: BehaviorSubject<SubTicket[]> = new BehaviorSubject<SubTicket[]>(
    null,
  );
  mappingAfterTicket$ = new BehaviorSubject<Ticket[]>([]);

  constructor(
    public basketService: BasketService,
    public apiService: ApiService,
    public appService: AppService,
  ) {}
  isLocalCheck(local: boolean) {
    this.isLocal = new BehaviorSubject(local);
    this.appService.isLocalFiiling(local);
    let tickets = this.tickets$.value;
    let FOREIGNCURRENCYID =
      tickets.find((x) => x.ISLOCAL == 0)?.CURRENCYID || 142;
    if (local === false) {
      this.ExchangeRate(FOREIGNCURRENCYID);
    } else {
      this.appService.exchangeRateFiiling(1);
    }
    this.mappingAfterGetData(this.tickets$.value);
  }
  private destroy$ = new Subject<void>();
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  ExchangeRate(FOREIGNCURRENCYID) {
    //doviz
    this.apiService
      .getExchangeRate(FOREIGNCURRENCYID)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.appService.exchangeRateFiiling(data[0][0].BUYRATE);
      });
  }

  addTicket(ticket: BasketTicketItem) {
    this.basketService.addTicket(ticket);
  }
  async getAllData() {
    let resp = await this.apiService.getData(moment().format('YYYY-MM-DD'));

    let data = JSON.parse(resp[0][0].Return);
    this.tickets$.next(data.TICKETS);

    this.appService.extensionScripts(data.EXTENTIONSCRIPT);
    this.appService.extraProducts$.next(data.EXTRAPRODUCTS);
    this.appService.setWebsite(
      JSON.parse(data.SETTINGS[0].SETTINGS),
      data.COMPANYINFO[0],
      data.LANGUAGES,
    );
    this.appService.progressBool();

    //  console.log('Tickets', data.TICKETS);
    // console.log('Settings', this.appService.settings$.value);
  }

  mappingAfterGetData(tickets: SubTicket[]) {
    tickets = tickets.filter((x) => x.ISLOCAL === (this.isLocal.value ? 1 : 0));
    console.log('beforeMappingTickets', tickets);

    let tempTicket: Ticket[] = [];
    // let tempSubTicket: {adult:ResponseGetTicket,children:ResponseGetTicket};

    tickets.forEach((ticket) => {
      if (ticket.PRODUCTTYPEID == 101 || ticket.PRODUCTTYPEID == 102) {
        let index = tempTicket.findIndex(
          (x) => x['TICKETNAME'] === ticket.TICKETNAME,
        );
        if (index === -1) {
          tempTicket.push({
            TICKETNAME: ticket.TICKETNAME,
            TICKETDETAIL: ticket.TICKETDETAIL,
            TICKETURL: ticket.PRODUCTURL,
            CURRENCY: ticket?.CURRENCY,
            CURRENCYID: ticket?.CURRENCYID,
            BASKETGROUPNO: ticket?.BASKETGROUPNO,
            TICKETNAME_I18N: ticket?.TICKETNAME_I18N,
            TICKETDETAIL_I18N: ticket?.TICKETDETAIL_I18N,
            SUBTICKETS: { ADULT: null, CHILDREN: null },
          });
          if (ticket.PRODUCTTYPEID == 101) {
            tempTicket[tempTicket.length - 1].SUBTICKETS.ADULT = ticket;
          } else if (ticket.PRODUCTTYPEID == 102) {
            tempTicket[tempTicket.length - 1].SUBTICKETS.CHILDREN = ticket;
          }
        } else {
          if (ticket.PRODUCTTYPEID == 101) {
            tempTicket[index]['SUBTICKETS'].ADULT = ticket;
          } else if (ticket.PRODUCTTYPEID == 102) {
            tempTicket[index]['SUBTICKETS'].CHILDREN = ticket;
          }

          // tempTicket[index]['SUBTICKETS'].push(ticket);
        }
      }
    });
    console.log('afterMappingTickets', tempTicket);

    this.mappingAfterTicket$.next(tempTicket);

    this.appService.progressBool();
    return tempTicket;
  }
}
